import Logger from "./../lib/logger";
import { RepositoryFactory } from "./../repository/RepositoryFactory";
import { makeCancellable } from "vuex-cancellable-actions";

const MapJsonRepository = RepositoryFactory.get("mapJsonRepository");

export default {
  namespaced: true,
  state: {
    /** 選択地点番号 */
    selectedPoint: 0,
    /** 選択地点名 */
    selectedPointName: "",
    /** 地点登録番号 */
    registPointNum: 0,
    /** 市町村リスト */
    towns: [],
    /** リスク収集フラグ 0:初期値、1:収集確認ダイアログ表示中、2:収集確認ダイアログでOK押下 */
    riskFlg: 0,
    /** アイコン変更フラグ 0:初期値、1:変更中 */
    iconEditFlg: 0,
    /** 削除フラグ 0:初期値、1:削除確認ダイアログ表示中 */
    deleteFlg: 0,
  },
  mutations: {
    /** 選択中地点番号 */
    setSelectedPoint(state, point) {
      this._vm.$log.debug("[ViewConfig]mut - setSelectedPoint(" + point + ")");
      state.selectedPoint = point;
    },
    /** 選択地点名 */
    setSelectedPointName(state, name) {
      this._vm.$log.debug(
        "[ViewConfig]mut - setSelectedPointName(" + name + ")"
      );
      state.selectedPointName = name;
    },
    setRegistPointNum(state, point) {
      this._vm.$log.debug("[ViewConfig]mut - setRegistPointNum(" + point + ")");
      state.registPointNum = point;
    },
    /** 市町村リスト */
    setTowns(state, towns) {
      this._vm.$log.debug("[ViewConfig]mut - setTowns(" + towns + ")");
      state.towns = towns;
    },
    /** リスク収集フラグ */
    setRiskFlg(state, riskFlg) {
      this._vm.$log.debug("[ViewConfig]mut - setRiskFlg(" + riskFlg + ")");
      state.riskFlg = riskFlg;
    },
    /** アイコン変更フラグ */
    setIconEditFlg(state, iconEditFlg) {
      this._vm.$log.debug(
        "[ViewConfig]mut - setIconEditFlg(" + iconEditFlg + ")"
      );
      state.iconEditFlg = iconEditFlg;
    },
    /** 削除フラグ */
    setDeleteFlg(state, deleteFlg) {
      this._vm.$log.debug("[ViewConfig]mut - setDeleteFlg(" + deleteFlg + ")");
      state.deleteFlg = deleteFlg;
    },
  },
  actions: makeCancellable({
    async getTwns({ commit }, { minlat, minlon, maxlat, maxlon }) {
      Logger.debug(
        "[ViewConfig]act - getTwns({*},{" +
          minlat +
          "," +
          minlon +
          "," +
          maxlat +
          "," +
          maxlon +
          "})"
      );
      // 市町村判定リスト
      const {
        data: townData,
        townError,
      } = await MapJsonRepository.getTownList();
      Logger.debug("[Telemeter] getTownList()");
      let towns = [];
      if (!townError) {
        var twonJudgeList = townData.towns;
      }
      twonJudgeList.forEach((town) => {
        // 取得範囲内の市町村に絞る
        let pushFlg = true;
        // 小数点計算の誤差を無くすため10*9倍にして計算する
        if (town.maxLat * Math.pow(10, 9) < minlat * Math.pow(10, 9)) {
          pushFlg = false;
        } else if (town.maxLon * Math.pow(10, 9) < minlon * Math.pow(10, 9)) {
          pushFlg = false;
        } else if (town.minLat * Math.pow(10, 9) > maxlat * Math.pow(10, 9)) {
          pushFlg = false;
        } else if (town.minLon * Math.pow(10, 9) > maxlon * Math.pow(10, 9)) {
          pushFlg = false;
        }
        if (pushFlg) {
          towns.push(town);
        }
      });
      commit("setTowns", towns);
    },
  }),
};
